<template>
  <v-layout row wrap>
    <v-flex xs12>
      <input class="d-file-uploader__input" type="file" ref="file" :accept="getExtension()" @change="selectFile">
      <div
              :loading="false"
              :disabled="false"
              class="bpm-file-btn"
              @click="openFileDialog()"
      >
        {{ name }}
        <v-icon right dark>cloud_upload</v-icon>
      </div>
    </v-flex>
    <v-flex xs12 class="bpm-file-name">
      {{ fileName }}
    </v-flex>
  </v-layout>
</template>

<style>

  .bpm-file-btn {
    background-color: #a9a9b2;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    font-size: 15px;
    padding: 6px 20px;
    text-transform: none;
    margin-bottom: 10px;
    width: auto;
    display: inline-block;
  }

  .bpm-file-btn:hover {
    background-color: #c2c2cd;
  }

  .bpm-file-name {
    color: #777787;
    font-size: 15px;
  }

</style>

<script>

import formComponent from '../mixins/form_component'
import defaultParser from '../parsers/file_parser'

export default {

  name: 'FormFile',

  mixins: [ formComponent ],

  /**
   *
   *
   */
  props: {

  },

  /**
   *
   *
   */
  data() {

    return {

      // Название выбранного файла
      fileName: '',

      // Список доступных расширений файлов
      extensions: []
    }
  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     * Инициализация компонента.
     *
     *  - подключение парсера
     *  - инициализация данных и значения по умолчанию
     *
     */
    init() {

      // Инициализация парсера.
      this.initParser( defaultParser )

      this.name = this.parser.getName( this.data )
      this.description = this.parser.getDescription( this.data )
      this.extensions = this.parser.getExtension( this.data )
      this.isRequired = this.parser.getRequired( this.data )
    },

    /**
     * Открытие диалогового окна для выбора файла.
     *
     */
    openFileDialog() {

      if ( this.$refs && this.$refs.file ) {
        this.$refs.file.click()
      }
    },

    /**
     * Получение выбранного файла.
     *
     */
    selectFile( e ) {

      let files = e.target.files || e.dataTransfer.files

      if ( !files.length ) return

      let file = files[ 0 ];

      this.fileName = file.name
      this.$emit( 'file', file )
    },

    /**
     * Получение списка доступных расширений файлов.
     *
     * Возвращается строка типа ".jpg,.gif,.png"
     *
     * @returns {string}
     */
    getExtension() {
      return '.' + this.extensions.join( ',.' )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/form/FormFile.vue